import React, { Component } from 'react';
import Card from 'antd/es/card/Card';
import { Collapse, CollapseProps, Typography } from 'antd';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';
import { INewsItem } from '../../user';

const { Paragraph } = Typography;
interface IProps {
  newsList: INewsItem[];
}

class _NewsBlock extends Component<IProps> {
  static contextType = AppContext;

  render(): React.ReactNode {
    const breakPoint = this.context as AppContextValue;

    if (!this.props.newsList.length) {
      return null;
    }

    const items: CollapseProps['items'] = this.props.newsList.map(n => ({
      key: n.newsId,
      label: n.title,
      children: <Paragraph style={{ whiteSpace: 'pre-wrap', marginTop: 24 }}>{n.body}</Paragraph>,
    }));
    const activeKey = this.props.newsList.map(n => n.newsId);

    if (breakPoint?.isMobile) {
      return <Collapse items={items} />;
    }

    return (
      <Card bordered={false} title="Новости" style={{ marginBottom: 8 }}>
        <Collapse items={items} defaultActiveKey={activeKey} />
      </Card>
    );
  }
}

export const NewsBlock = _NewsBlock;
